import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const SubcategoriesRow = styled.div`
  width: 100%;
  /* min-height: 38px;
  max-height: fit-content; */
  margin-bottom: ${SPACING._8};
`;

export const BadgesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING._8};
`;
